import React from "react";
import classnames from "classnames";

import { CommonProps, getClasses } from "./buttonCommon";
import { LocaleLink, LocaleLinkProps } from "./api/LocaleLink";
import { replaceClasses } from "../utils/replaceClasses";

// TODO: handle disabled state properly?

export const GatsbyLink = (props: CommonProps & LocaleLinkProps) => {
  const { size, kind, iconLeft, iconRight, children, disabled, className, classNameOverride, ...p } = props;
  if (kind === "link") {
    const cls = replaceClasses(
      classnames("inline text-blue underline hover:text-info", {
        "cursor-not-allowed": disabled,
        "text-button-disabled-text": disabled,
        "hover:text-button-disabled-text": disabled,
      }),
      classNameOverride
    );
    return (
      <LocaleLink className={cls} {...p}>
        {children}
      </LocaleLink>
    );
  }
  const c = getClasses(size, kind, disabled);
  return (
    <LocaleLink className={replaceClasses(classnames(c.sizeClass, c.kindClass, className), classNameOverride)} {...p}>
      {iconLeft ? iconLeft({ className: c.iconClass }) : null}
      <span className="align-middle">{children}</span>
      {iconRight ? iconRight({ className: c.iconClass }) : null}
    </LocaleLink>
  );
};
